export const homeConstants = {
    LOAD_HOME_DATA_REQUEST: 'LOAD_HOME_DATA_REQUEST',
    LOAD_HOME_DATA_SUCCESS: 'LOAD_HOME_DATA_SUCCESS',
    LOAD_HOME_DATA_FAILURE: 'LOAD_HOME_DATA_FAILURE',
};
